import './services.settings.css';
import TabBar from '../../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import { ServicesSettingsPaymentTypes } from './tabs-componenets/services.settings.payment-types';
import { ScholarshipFunders } from './scholarship-funders/scholarship-funders';
import { ServicesSettingsCheckPayment } from './tabs-componenets/check-payment-services/services.settings.check-payment';

const tabs = [
  'סוגי שרותים',
  'גופי מימון חיצוניים לסטודנט',
  'עמלה להמחאה חוזרת',
];

const ServicesSettings = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 350);
  };

  const pages = [
    <ServicesSettingsPaymentTypes />,
    <ScholarshipFunders />,
    <ServicesSettingsCheckPayment />,
  ];

  return (
    <div className={'services-settings-body-page'}>
      <div className={'studies-settings-title'}>הגדרות מערכת</div>

      <TabBar
        tabs={tabs}
        onClick={(index) => {
          onTabSelected(index);
          console.log('The index ' + index + 'Is clicked');
        }}
      ></TabBar>
      <br />

      <div>{pages[selectedIndex]}</div>
    </div>
  );
};

export default ServicesSettings;
